import styled from 'styled-components';
import { ResultMatchType } from './types';

export const ResultMatchHighlight = styled.span`
  color: ${({ theme }) => theme.colors.gray['100']};
  text-transform: none;
`;

export const ResultMatchHighlightAll = styled.span<{ type: ResultMatchType }>`
  color: ${({ theme, type }) => theme.colors.gray[type === ResultMatchType.Label ? '100' : '090']};
  text-transform: none;
`;
